<template>
  <div class="site-header">
    <div class="container">
      <div class="header-logo">
        <a href="/" title="青岛精科商城" class="logo ir">青岛精科商城</a>
      </div>
      <div class="header-search" style="width: 316px">
        <el-autocomplete placeholder="请输入内容" clearable style="width: 316px;height:50px;line-height:50px;"
          v-model="keyword" :fetch-suggestions="querySearch" :trigger-on-focus="false" @select="handleSelect"
          @keydown="onKeydown($event)">
          <template #append>
            <el-button class="iconfont x-sousuo" @click="onSearch()"></el-button>
          </template>
          <template #default="{ item }">
            <div class="value" :title="item.value">{{ item.value }}</div>
          </template></el-autocomplete>
      </div>
      <div class="header-nav" style="width: 100%;">
        <ul class="nav-list J_navMainList clearfix">
          <li class="nav-category" @mouseenter="showCate()" @mouseleave="hideCate()" style="width:234px;">
            <a class="link-category" style="text-align: center;"><span class="text">全部商品分类</span></a>
          </li>
          <li class="nav-item" v-for="(item, index) in site_nav_tree" :key="index">
            <a :href="item.url" class="link">
              <span class="text">{{ item.name }}</span>
            </a>
            <ul class="submenu">
              <li v-for="sub in item._child">
                <a :href="sub.url" class="link">
                  <span class="text">{{ sub.name }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { api, session } from "@/assets/js/util.js";
export default {
  name: "SiteHeader",
  inject: ["reload", "global"],
  data() {
    return {
      keyword: "",
      options: [],
      site_nav: [],
      site_nav_tree: [],
    };
  },
  props: {
    msg: String,
  },
  mounted() {
    this.keyword = this.$route.query.keyword;
    this.getData();
  },
  methods: {
    showCate() {
      this.global.isOnCate = false;
      this.global.isShowCate = true;
      console.log(this.global.isShowCate);
    },
    hideCate() {
      let that = this;
      setTimeout(function () {
        if (!that.global.isOnCate) {
          that.global.isShowCate = false;
        }
      }, 300);
    },
    querySearch(queryString, callback) {
      api.get("get_search", { query: queryString }).then(function (res) {
        if (res.code) {
          callback(res.data.list);
        }
      });
    },
    onSearch() {
      if (this.$route.name === "Search") {
        this.$route.query.keyword = this.keyword;
        this.reload();
      } else {
        this.$router.push({
          path: "/search",
          query: { keyword: this.keyword },
        });
      }
    },
    onKeydown(event) {
      if (event.keyCode === 13) {
        this.onSearch();
      }
    },
    handleSelect(item) {
      this.$router.push(item.link);
      //this.$router.push({ name: "Transfer", params: { url: item.link } });
    },
    getData() {
      let that = this;
      let site_nav_tree = session.get("site_nav_tree");

      if (!site_nav_tree === true) {
        api.get("site_nav").then(function (res) {
          if (res.code) {
            session.set("site_nav_tree", res.data.site_nav_tree);
            that.site_nav_tree = session.get("site_nav_tree");
          }
        });
      } else {
        that.site_nav_tree = session.get("site_nav_tree");
      }
    },
  },
};
</script>
<style>
.nav-item:hover>a,
.submenu li:hover>a {
  color: #2794eb !important;
}

.nav-item:hover>a::before {
  background-color: #2794eb !important;
}

.submenu {
  position: absolute;
  padding-left: 20px;
  padding-left: 0px;
  width: 190px;
  margin-top: 0px;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.2);
  display: none;
}

.nav-item:hover .submenu {
  display: block;
}

.nav-item {
  position: relative;
}

.submenu li {
  display: block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
}

.submenu li a {
  padding: 0 !important;
  height: 40px;
  line-height: 40px;
}

li:hover .submenu {
  display: block;
}

.site-header .logo,
.site-header .logo:hover {
  width: 500px !important;
  height: 90px !important;
}

.submenu {
  background-color: #fff;
  z-index: 99999;
}

.site-header {
  height: 180px !important;
}

.site-header .header-logo {
  width: 480px !important;
}

.site-header .logo:before,
.site-header .logo:hover::after {
  width: 100%;
  height: 90px !important;
}

.site-header .logo:before,
.site-header .logo::after {
  height: 100px;
  width: 580px !important;
  background-size: contain !important;
}

.site-header .nav-list {
  height: 50px !important;
  line-height: 50px;
  padding-left: 0px !important;
}

.site-header .nav-list li {
  height: 50px !important;
  line-height: 50px;
}

.site-header .nav-list li a {
  height: 50px !important;
  line-height: 50px;
  padding: 0 10px !important;
}
</style>